'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.single-residence').length <= 0 ) {
        return
    }

    const $body           = $('body')
    const $headerHeight   = $('#header').height()
    const $galleryTrigger = $('#cursorWrapper')
    const galleryCursor   = '#galleryCursor'
    const $slider         = $('.slider-residence')

    // Custom cursor gallery
    $galleryTrigger.css({
        cursor: 'none'
    })

    $galleryTrigger.hover(
        function() {
            gsap.fromTo(
                galleryCursor,
                { scale: 0 },
                { scale: 1 },
            )

            $(this).mousemove( function(e) {
                const x = e.pageX
                const y = e.pageY - $headerHeight

                gsap.to(galleryCursor, 2, {
                    top: 0,
                    left: 0,
                    xPercent: -50,
                    yPercent: -50,
                    x: x,
                    y: y,
                    ease: "power4.out"
                })
            })
        },
        function() {
            gsap.fromTo(
                galleryCursor,
                { scale: 1 },
                { scale: 0 },
            )
        }
    )

    // Image gallery
    const gallery = new Swiper('.slider-residence__container', {
        init: false,
        slidesPerView: 1,
        speed: 500,
        spaceBetween: 0,
        parallax: true,
        grabCursor: true,
        pagination: {
            el: '.slider-residence__pagination',
            type: 'custom',
            renderCustom: (swiper, current, total) => current.toString().padStart(2, '0') + ' / ' + (total).toString().padStart(2, '0'),
        },
        navigation: {
            prevEl: '.slider-residence__nav-item--prev',
            nextEl: '.slider-residence__nav-item--next',
        },
        on: {
            init: function() {
                $('.slider-residence__nav-item--prev').addClass('slider-residence__nav-item--hidden')
            },
            transitionStart: function ( swiper ) {
                if ( swiper.activeIndex === 0 ) {
                    $('.slider-residence__nav-item--prev').addClass('slider-residence__nav-item--hidden')
                } else {
                    $('.slider-residence__nav-item--prev').removeClass('slider-residence__nav-item--hidden')
                }

                console.log('active', swiper.activeIndex)
                console.log('total', swiper.slides.length)

                if ( swiper.activeIndex === swiper.slides.length - 3 ) {
                    swiper.allowSlideNext = false
                    $('.slider-residence__nav-item--next').addClass('slider-residence__nav-item--hidden')
                } else {
                    swiper.allowSlideNext = true
                    $('.slider-residence__nav-item--next').removeClass('slider-residence__nav-item--hidden')
                }
            }
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                spaceBetween: 70,
                pagination: {
                    el: '.slider-residence__pagination',
                    type: 'custom',
                    renderCustom: (swiper, current, total) => current.toString().padStart(2, '0') + ' / ' + (total - 1).toString().padStart(2, '0'),
                },
            }
        }
    })

    $('#cursorWrapper, .main-gallery').on('click', function() {
        $body.addClass('no-scroll')
        gallery.init()
        $slider.addClass('is-active')
    })

    $('.slider-residence__close').on('click', function() {
        $body.removeClass('no-scroll')
        $slider.removeClass('is-active')
        setTimeout(function() {
            gallery.slideTo(0, 0)
        }, 1000)
    })

    // Line clamp testimonial
    $('#readMore').on('click', function () {
        const $this = $(this)
        gsap.to( '#testimonial', .5, {
            height: 'auto',
            onComplete : function() {
                gsap.to( $this, 1, { opacity: 0, pointerEvents: 'none' } )
            }
        })
    })
}
